import { Anchor, type AnchorProps, CloseButton, Group } from "@mantine/core"
import type { PropsWithChildren } from "react"
import { useTranslation } from "react-i18next"
import { useAppModal } from "../controls"
import { icons } from "./icons"

export function HowItWorks({ children, ...props }: PropsWithChildren<AnchorProps>) {
  const { t } = useTranslation()
  const { open, close } = useAppModal()

  return (
    <Anchor
      {...props}
      fw={500}
      variant="link"
      onClick={() =>
        open({
          size: "xl",
          title: null,
          withCloseButton: false,
          children: (
            <>
              {children}
              <CloseButton pos="absolute" top={15} right={10} onClick={close} />
            </>
          ),
        })
      }
    >
      <Group gap={4}>
        {t("How it works")}
        <icons.Help size={20} />
      </Group>
    </Anchor>
  )
}
